import { clamp } from 'gsap/gsap-core';
import ResizeManager from '../managers/ResizeManager';
import AbstractComponent from './AbstractComponent';
import { Smoother } from 'core/Smooth';
import ResizeObserver from 'resize-observer-polyfill';
class LoopText extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.update = this.update.bind(this);
    this.handleResizeObserver = this.handleResizeObserver.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$child = ui.$element.querySelector('span');
    return ui;
  }

  initializeBeforeEvents() {
    const resizer = new ResizeObserver(this.handleResizeObserver);
    const observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.0,
    });

    resizer.observe(this.ui.$child);
    observer.observe(this.ui.$element);

    this.progress = 0;
    this.resizer = resizer;
    this.observer = observer;
    this.scrollProgress = Smoother.add({
      precision: 4,
      smooth: 0.1,
      min: 0,
      max: 300,
    });
  }

  handleIntersection([entry]) {
    const { isIntersecting, intersectionRatio } = entry;
    const isInViewport = isIntersecting || intersectionRatio > 0;

    if (isInViewport) {
      this.rafId = requestAnimationFrame(this.update);
    } else {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  handleScroll(scrollTop) {
    if (this.previousScrollTop) {
      this.scrollSpeed = clamp(-130, 130, scrollTop - this.previousScrollTop) / 130;
    }

    this.scrollProgress.target =
      300 * (scrollTop / (ResizeManager.scrollHeight - ResizeManager.height));

    this.previousScrollTop = scrollTop;
  }

  handleResizeObserver([entry]) {
    if (this.ui.$clones?.length > 0) {
      this.ui.$clones.forEach(($clone) => $clone.remove());
      this.ui.$clones = [];
    }

    const parentWidth = this.ui.$element.offsetWidth;
    const width = this.ui.$child.offsetWidth;
    const nbClones = Math.ceil(parentWidth / width);

    const $clones = [];
    for (let i = 0; i < nbClones; i++) {
      const $clone = this.ui.$child.cloneNode(true);
      $clones.push($clone);
      this.ui.$element.appendChild($clone);
    }

    this.width = width;
    this.ui.$clones = $clones;
  }

  update() {
    if (this.rafId === null) return;

    if (this.width) {
      this.progress += 1;
      const value = ((this.progress + this.scrollProgress.value) * -1) % this.width;
      this.ui.$child.style.transform = `translateX(${value}px)`;
      this.ui.$clones.forEach(($clone) => ($clone.style.transform = `translateX(${value}px)`));
    }

    this.rafId = requestAnimationFrame(this.update);
  }
}

export default LoopText;
